// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "webaser-" + {"786":"cwm","874":"antd"}[chunkId] + ".css";
};